import "./PrivateTagSkillListing.css";
import { Avatar, Tooltip } from "antd";

const PrivateTagSkillListing = ({ tooltipPlacement = 'bottom', ...props }) => {
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  return (
    <Tooltip placement={tooltipPlacement} title="This is a private candidate">
      {/* <p style={{ display: "none" }}></p> */}
      <div className="PvtTag-Cantainer">
        <Avatar
          size={24}
          src={`${process.env.REACT_APP_S3_URL}/${userProfile?.Profiles?.PictureUrl}`}
        >
        </Avatar>
      </div>
    </Tooltip>
  );
};

export default PrivateTagSkillListing;
